module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"choose.file":"Choisissez un fichier","choose.files":"Choisissez plusieurs fichiers","file.chosen":"Un fichier a été sélectionné","files.chosen":"{countFiles} fichiers ont été sélectionnés"}}')
  delete Component.options._Ctor
}
